import { Link } from "react-router-dom";
import { Heart, Trash2, ShoppingBag } from "lucide-react";
import { gbp } from "@/lib/api";
import { useWishlist } from "@/context/WishlistContext";
import { useCart } from "@/context/CartContext";

export default function Wishlist() {
  const { items, remove } = useWishlist();
  const { addItem } = useCart();

  if (items.length === 0)
    return (
      <div className="container-furn py-24 text-center">
        <Heart className="mx-auto h-12 w-12 text-muted-foreground" />
        <h1 className="mt-5 font-display text-4xl font-bold uppercase">Your wishlist is empty</h1>
        <p className="mt-3 text-muted-foreground">Save the gear you love for later.</p>
        <Link to="/shop" className="mt-6 inline-block bg-accent px-8 py-4 text-xs font-bold uppercase tracking-widest text-accent-foreground">Browse tackle</Link>
      </div>
    );

  return (
    <div className="container-furn py-12">
      <h1 className="mb-8 font-display text-4xl font-bold uppercase tracking-tight">Wishlist ({items.length})</h1>
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {items.map((i) => (
          <div key={i.product_id} className="flex gap-4 border border-border bg-card p-4">
            <Link to={`/product/${i.slug}`} className="h-24 w-24 shrink-0 overflow-hidden bg-secondary"><img src={i.image} alt={i.name} className="h-full w-full object-cover" /></Link>
            <div className="flex flex-1 flex-col">
              <span className="overline">{i.brand}</span>
              <Link to={`/product/${i.slug}`} className="font-medium leading-snug hover:text-accent transition-colors line-clamp-2">{i.name}</Link>
              <span className="mt-1 font-display font-bold">{gbp(i.price)}</span>
              <div className="mt-auto flex gap-2 pt-2">
                <button onClick={() => addItem({ id: i.product_id, slug: i.slug, name: i.name, brand: i.brand, price: i.price, images: [i.image] })} className="flex flex-1 items-center justify-center gap-1.5 bg-primary py-2 text-[10px] font-bold uppercase tracking-widest text-primary-foreground hover:brightness-125 transition-[filter]"><ShoppingBag className="h-3.5 w-3.5" /> Add</button>
                <button onClick={() => remove(i.product_id)} className="grid h-8 w-8 place-items-center border border-border hover:border-destructive hover:text-destructive transition-colors"><Trash2 className="h-3.5 w-3.5" /></button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
